export enum CandidateActionTypes {
    NOT_APPROVED = 'NOT_APPROVED',
    NOT_INTERVIEWED = 'NOT_INTERVIEWED',
    DECLINED_PROPOSAL = 'DECLINED_PROPOSAL',
    HIRED = 'HIRED'

}

export interface DeclineCandidateReason {
    id: string;
    name: string;
    type: CandidateActionTypes;
}
